const hashCache = new Map<string, string>();

function simpleHash(text: string, length: number = 8): string {
    let hash = 5381;
    for (let i = 0; i < text.length; i++) {
        hash = (hash * 33) ^ text.charCodeAt(i);
    }
    return (hash >>> 0).toString(16).padStart(8, "0").substring(0, length);
}

export function generateHashKey(text: string): string {
    const normalized = text.trim().toLowerCase().replace(/\s+/g, " ");
    return `k_${simpleHash(normalized)}`;
}

export function getHashKey(text: string): string {
    if (hashCache.has(text)) return hashCache.get(text)!;
    const key = generateHashKey(text);
    hashCache.set(text, key);
    return key;
}

export function i18nKey(text: string): { "data-i18n": string } {
    return { "data-i18n": getHashKey(text) };
}
